import withApiData from "../withApiData";
import withOptimize from "./withOptimize";
import Header from "./Header";
import Placeholder from "./Placeholder";

export default withApiData(withOptimize(Header, Placeholder), Placeholder);
